function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var CartActive = function CartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M12.001 4.127H5.856l-.245-1.311A1 1 0 0 0 4.628 2H2a1 1 0 0 0 0 2h1.798l1.795 9.577a1 1 0 0 0 .025.128l.065.349c.176 1.54 1.132 4.15 3.603 4.15h11.54a1 1 0 0 0 0-2H9.285c-.867 0-1.296-1.057-1.489-1.783l11.426-.327c1.799-.231 2.68-1.238 3.111-2.44a8 8 0 0 1-2.785.334 2.3 2.3 0 0 1-.482.114L7.41 12.43l-1.18-6.304h6.055a8 8 0 0 1-.285-2m-.782 16.69c0-.804-.655-1.46-1.46-1.46a1.46 1.46 0 1 0 1.46 1.46m9.335 0c0-.804-.655-1.46-1.46-1.46s-1.46.656-1.46 1.46a1.46 1.46 0 0 0 2.92 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F81B40",
    fillRule: "evenodd",
    d: "M20 0c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4",
    clipRule: "evenodd"
  }));
};
export default CartActive;